import * as React from "react";
import { useRouteMatch } from "react-router-dom";
import { ILimitsRouteParams } from "../../../types/components/limits/limitsTypes";
import LimitsHeader from "../generic/limitsHeader";

import "../../../../assets/scss/components/toc/limits/limitsDsk.scss";
import LimitsLeftCol from "../generic/limitsLeftCol";
import LimitsRightCol from "../generic/limitsRightCol";
import Tab from "../../../generic/tab";
import Loader from "../../../generic/loader";
import { IListObj } from "../../../types/genericTypes";
import NoDataContainer from "../../../generic/noDataContainer";

export interface ILimitsLayoutTabProps {
	limitsData: any;
	secNavOptions: Array<IListObj>;
	showLoader: boolean;
	tryAgain: () => void;
}

const LimitsLayoutTab: React.FC<ILimitsLayoutTabProps> = (props) => {
	const routeParams = useRouteMatch<ILimitsRouteParams>();

	return (
		<section className="outer_container container_tab limits">
			<section className="lyCont">
				<section className="margin_tab">
					<div className="mrgn_hdr_tab">
						<Tab defaultValue={routeParams.params.asset || "equity"} tabList={props.secNavOptions} position="center" />
					</div>
					<div className="limits_tab">
						{/* If there is header in limitsdata, then we have got api response, otherwise it is still loading */}
						{props.showLoader ? (
							<div className="limits_loader_cont">
								<Loader size={20} color="blue" />
							</div>
						) : props.limitsData.header ? (
							<div className="limits_cont_tab">
								<div className="ib col col1">
									<LimitsHeader
										label="Available Limits"
										value={props.limitsData.header?.availableLimits}
										cshAvl={props.limitsData.header?.cshAvl}
										showAddWithdrawBtn
									/>
								</div>

								<div className="ib col col2">
									<LimitsHeader label="Utilised Limits" value={props.limitsData.header?.utilizedLimits} />
								</div>

								<div className="thick_divider" />

								<div className="ib col col1">
									<LimitsLeftCol {...props.limitsData.leftCol} />
								</div>
								<div className="ib col col2">
									<LimitsRightCol {...props.limitsData.rightCol} />
								</div>
							</div>
						) : (
							<NoDataContainer txtHeading="Something Went Wrong" linkDet={{ txt: "Try Again", type: "btn", clickHandler: props.tryAgain }} />
						)}
					</div>
				</section>
			</section>
		</section>
	);
};

export default LimitsLayoutTab;
